import PageNotFound from "../Main/PageNotFound";
import ErrorPage from "../Main/ErrorPage";
import AccessDeniedPage from "../Main/AccessDeniedPage";
import { isPageNotFound, isAccessDenied } from "../Utils/errorsHandling";
import BaseErrorBoundary from "./BaseErrorBoundary";

class BaseErrorBoundaryWithRenderer extends BaseErrorBoundary {
  handleModalClosed() {
    window.history.back();
  }

  renderErrorComponent() {
    if (isAccessDenied(this.error)) {
      return <AccessDeniedPage />;
    } else if (isPageNotFound(this.error)) {
      return <PageNotFound />;
    } else {
      return <ErrorPage />;
    }
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return this.renderErrorComponent();
  }
}

export default BaseErrorBoundaryWithRenderer;
